import { produce } from 'immer';
import { entity } from 'simpler-state';

import { SignUpFormWithPolicies, SignUpFormWithPoliciesValue } from './EnrollmentState.constants';

const INITIAL_STATE: { form: SignUpFormWithPolicies } = { form: SignUpFormWithPoliciesValue };

const self = entity(INITIAL_STATE);

const setForm = (value: SignUpFormWithPolicies): void => {
  self.set(
    produce(state => {
      state.form = value;// eslint-disable-line no-param-reassign
    }),
  );
};

const setFirstName = (value: string): void => {
  self.set(
    produce(state => {
      state.form.firstName = value;// eslint-disable-line no-param-reassign
    }),
  );
};

const setLastName = (value: string): void => {
  self.set(
    produce(state => {
      state.form.lastName = value;// eslint-disable-line no-param-reassign
    }),
  );
};

const setCountry = (value: string): void => {
  self.set(
    produce(state => {
      state.form.country = value;// eslint-disable-line no-param-reassign
    }),
  );
};

const setEmail = (value: string): void => {
  self.set(
    produce(state => {
      state.form.email = value;// eslint-disable-line no-param-reassign
    }),
  );
};

const setPassword = (value: string): void => {
  self.set(
    produce(state => {
      state.form.password = value;// eslint-disable-line no-param-reassign
    }),
  );
};

const setPrivacyPolicyApproved = (value: boolean): void => {
  self.set(
    produce(state => {
      state.form.isPrivacyPolicyApproved = value;// eslint-disable-line no-param-reassign
    }),
  );
};

const setPersonalInfoStepPassed = (value: boolean): void => {
  self.set(
    produce(state => {
      state.form.steps.isPersonalInfoPassed = value;// eslint-disable-line no-param-reassign
    }),
  );
};

const setAuthInfoStepPassed = (value: boolean): void => {
  self.set(
    produce(state => {
      state.form.steps.isAuthInfoPassed = value;// eslint-disable-line no-param-reassign
    }),
  );
};

const setVerifyEmailStepPassed = (value: boolean): void => {
  self.set(
    produce(state => {
      state.form.steps.isVerifyEmailPassed = value;// eslint-disable-line no-param-reassign
    }),
  );
};

const setVerifyPhoneStepPassed = (value: boolean): void => {
  self.set(
    produce(state => {
      state.form.steps.isVerifyPhonePassed = value;// eslint-disable-line no-param-reassign
    }),
  );
};

const setVerifyPhoneContinueSubmitted = (value: boolean): void => {
  self.set(
    produce(state => {
      state.form.steps.isVerifyPhoneContinueSubmitted = value;// eslint-disable-line no-param-reassign
    }),
  );
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  use: () => self.use(data => data),
  setForm,
  setFirstName,
  setLastName,
  setCountry,
  setEmail,
  setPassword,
  setPrivacyPolicyApproved,
  setPersonalInfoStepPassed,
  setAuthInfoStepPassed,
  setVerifyEmailStepPassed,
  setVerifyPhoneStepPassed,
  setVerifyPhoneContinueSubmitted,
  resetForm: () => setForm(SignUpFormWithPoliciesValue),
};
